import { createFileRoute } from '@tanstack/react-router'

import { AllInFlipOutsRoute } from '@/pages/promotion/route-entries/all-in-flip-outs'

export const Route = createFileRoute('/_layout/promotion/august-2025/_tabs/all-in-flip-outs')({
  component: AllInFlipOutsRoute,
})
